<!--教研工具：第三方教学工具集合（数据整理自 edui123.com）-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="tools-page">
            <!--页头-->
            <div class="page-head">
                <div class="head-left">
                    <div class="page-title">教研工具</div>
                    <div class="page-sub">精选 {{ totalCount }} 个第三方教学工具，覆盖备课、授课、评价与资源处理全场景</div>
                </div>
                <div class="head-search">
                    <el-input
                        v-model="keyword"
                        placeholder="搜索工具名称或简介"
                        clearable>
                        <template #prefix>
                            <el-icon><Search /></el-icon>
                        </template>
                    </el-input>
                </div>
            </div>

            <!--分类导航-->
            <div class="cate-nav">
                <div
                    class="cate-pill"
                    :class="{active: activeCate === ''}"
                    @click="activeCate = ''">
                    全部<span class="cate-count">{{ totalCount }}</span>
                </div>
                <div
                    class="cate-pill"
                    v-for="c in visibleCategories"
                    :key="c.cate"
                    :class="{active: activeCate === c.cate}"
                    @click="activeCate = c.cate">
                    {{ c.cate }}<span class="cate-count">{{ c.tools.length }}</span>
                </div>
            </div>

            <!--工具列表-->
            <div class="tools-body">
                <template v-if="filteredGroups.length">
                    <div class="cate-group" v-for="g in filteredGroups" :key="g.cate">
                        <div class="group-title">
                            <span class="group-bar"></span>{{ g.cate }}
                            <span class="group-count">{{ g.tools.length }}</span>
                        </div>
                        <div class="tool-grid">
                            <div
                                class="tool-card"
                                v-for="t in g.tools"
                                :key="t.u"
                                :title="t.u"
                                @click="openTool(t)">
                                <div class="tool-avatar" :style="{background: avatarColor(t.n)}">{{ firstChar(t.n) }}</div>
                                <div class="tool-info">
                                    <div class="tool-name">{{ t.n }}</div>
                                    <div class="tool-desc">{{ t.d || '点击查看详情' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="empty-tip" v-else>未找到匹配「{{ keyword }}」的工具，换个关键词试试</div>
            </div>

            <div class="page-foot">教研工具（仅作导航聚合，服务内容由各第三方站点提供）</div>
        </div>
    </div>
</template>

<script>
import homeHead from "@/components/homeHead.vue";
import toolsData from "@/api/data/teachToolsData";

export default {
    components: {homeHead},
    name: "homeTeachTools",
    data() {
        return {
            activePath: "aiAssistant",
            keyword: "",
            activeCate: "",
            categories: toolsData,
            /*头像配色（主题蓝橙系）*/
            palette: ["#1f5aa8", "#2f7ed8", "#f29c2b", "#e0651f", "#3aa68c", "#7a5fd0", "#d05f8a", "#5a8f2f"],
        }
    },
    computed: {
        /*暂时隐藏链接指向 edui123 的工具，恢复时直接用 toolsData 即可*/
        visibleCategories() {
            return this.categories
                .map(c => ({
                    cate: c.cate,
                    tools: c.tools.filter(t => !(t.u || "").includes("edui123")),
                }))
                .filter(c => c.tools.length);
        },
        totalCount() {
            return this.visibleCategories.reduce((s, c) => s + c.tools.length, 0);
        },
        filteredGroups() {
            const kw = this.keyword.trim().toLowerCase();
            let list = this.activeCate
                ? this.visibleCategories.filter(c => c.cate === this.activeCate)
                : this.visibleCategories;
            if (!kw) return list;
            return list
                .map(c => ({
                    cate: c.cate,
                    tools: c.tools.filter(t =>
                        t.n.toLowerCase().includes(kw) || (t.d || "").toLowerCase().includes(kw)),
                }))
                .filter(c => c.tools.length);
        },
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        openTool(t) {
            window.open(t.u, "_blank");
        },
        firstChar(n) {
            return (n || "?").trim().charAt(0).toUpperCase();
        },
        avatarColor(n) {
            let h = 0;
            const s = n || "";
            for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
            return this.palette[h % this.palette.length];
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.tools-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 30px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center fixed;
    background-size: cover;
}

/*页头*/
.page-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    max-width: 1840px;
    margin: 0 auto 18px;
}
.page-title {
    font-size: 26px;
    font-weight: bold;
    color: #1f4e79;
}
.page-sub {
    margin-top: 6px;
    font-size: 14px;
    color: #6b7f95;
}
.head-search {
    width: 320px;
    flex-shrink: 0;
}
.head-search :deep(.el-input__inner) {
    border-radius: 19px;
    border-color: #bcd6ee;
}

/*分类导航*/
.cate-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 1840px;
    margin: 0 auto 20px;
    padding: 14px 16px;
    background: rgba(255, 255, 255, .82);
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(31, 90, 168, .08);
}
.cate-pill {
    padding: 6px 14px;
    font-size: 14px;
    color: #33546f;
    background: #eef5fc;
    border: 1px solid transparent;
    border-radius: 16px;
    cursor: pointer;
    user-select: none;
    transition: all .15s ease;
}
.cate-pill:hover {
    border-color: #1f5aa8;
    color: #1f5aa8;
}
.cate-pill.active {
    background: #1f5aa8;
    color: #fff;
}
.cate-count {
    margin-left: 5px;
    font-size: 12px;
    opacity: .7;
}

/*工具分组*/
.tools-body {
    max-width: 1840px;
    margin: 0 auto;
}
.cate-group {
    margin-bottom: 26px;
}
.group-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    color: #1f4e79;
    margin-bottom: 12px;
}
.group-bar {
    width: 5px;
    height: 18px;
    background: #f29c2b;
    border-radius: 3px;
    margin-right: 8px;
}
.group-count {
    margin-left: 8px;
    font-size: 13px;
    font-weight: normal;
    color: #8aa2b8;
}

/*工具卡片网格*/
.tool-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 14px;
}
.tool-card {
    display: flex;
    align-items: center;
    padding: 14px;
    background: rgba(255, 255, 255, .92);
    border: 1px solid #e2ecf5;
    border-radius: 10px;
    cursor: pointer;
    transition: all .18s ease;
}
.tool-card:hover {
    transform: translateY(-3px);
    border-color: #1f5aa8;
    box-shadow: 0 6px 16px rgba(31, 90, 168, .16);
}
.tool-avatar {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
    border-radius: 10px;
    margin-right: 12px;
}
.tool-info {
    min-width: 0;
}
.tool-name {
    font-size: 15px;
    font-weight: bold;
    color: #24455f;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tool-desc {
    margin-top: 4px;
    font-size: 12px;
    color: #8498ab;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.empty-tip {
    padding: 80px 0;
    text-align: center;
    font-size: 15px;
    color: #8aa2b8;
}

.page-foot {
    max-width: 1840px;
    margin: 10px auto 0;
    padding-top: 14px;
    border-top: 1px dashed #c9dcec;
    font-size: 12px;
    color: #9db2c5;
    text-align: center;
}
</style>
